import { call, put, takeEvery } from 'redux-saga/effects';
import { FetchPreSeasonProgramSetup, IProgramPreSeasonSetup, ProgramActionKeys, programsActionCreators } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import * as api from '../programsApi';

function* fetchProgramPreSeasonSetupSaga(action: FetchPreSeasonProgramSetup) {
  yield put(uiActionCreators.toggleLoading('programPreSeasonSetup'));
  const response: IApiExecuteRespone<IProgramPreSeasonSetup[]> = yield call(
    api.fetchProgramPreSeasonSetup,
    action.payload.fiscalYear
  );

  if (!response.requestFailed && response.value) {
    if (response.value) {
      yield put(programsActionCreators.setPreSeasonSetup(response.value));
    }
  } else {
    yield showFailedRequestDialog(response);
  }

  yield put(uiActionCreators.toggleLoading('programPreSeasonSetup'));
}

export function* watchFetchProgramPreSeasonSetup() {
  yield takeEvery(ProgramActionKeys.FETCH_PRESEASON_PROGRAM_SETUP, fetchProgramPreSeasonSetupSaga);
}
